export const PROJECT_DOCUMENTS_TOKEN_LOAD = 'PROJECT_DOCUMENTS_TOKEN_LOAD'
export const projectDocumentTokenLoad = (
  accountId: string,
  projectId: string
): ProjectDocumentTokenLoadAction => ({
  type: PROJECT_DOCUMENTS_TOKEN_LOAD,
  accountId,
  projectId
})

export const PROJECT_DOCUMENTS_TOKEN_LOAD_SUCCESS =
  'PROJECT_DOCUMENTS_TOKEN_LOAD_SUCCESS'
export const projectDocumentTokenLoadSuccess = (
  accountId: string,
  projectId: string,
  projectDocumentToken: string
): ProjectDocumentTokenLoadSuccessAction => ({
  type: PROJECT_DOCUMENTS_TOKEN_LOAD_SUCCESS,
  accountId,
  projectId,
  projectDocumentToken
})

export const PROJECT_DOCUMENTS_TOKEN_LOAD_FAIL =
  'PROJECT_DOCUMENTS_TOKEN_LOAD_FAIL'
export const projectDocumentTokenLoadFailure = (
  accountId: string,
  projectId: string,
  error
): ProjectDocumentTokenLoadFailAction => ({
  type: PROJECT_DOCUMENTS_TOKEN_LOAD_FAIL,
  accountId,
  projectId,
  error
})

// INTERFACEs
export interface ProjectDocumentTokenLoadAction {
  type: typeof PROJECT_DOCUMENTS_TOKEN_LOAD
  accountId: string
  projectId: string
}

interface ProjectDocumentTokenLoadSuccessAction {
  type: typeof PROJECT_DOCUMENTS_TOKEN_LOAD_SUCCESS
  accountId: string
  projectId: string
  projectDocumentToken: string
}

interface ProjectDocumentTokenLoadFailAction {
  type: typeof PROJECT_DOCUMENTS_TOKEN_LOAD_FAIL
  accountId: string
  projectId: string
  error: any
}
